import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    fill="none"
    {...props}
  >
    <path
      fill="#9BA2B0"
      d="M8.286 3.714H10V10H3.714V8.286H2V2h6.286v1.714Zm0 1.143v3.429H4.857v.571h4v-4h-.571ZM3.143 3.143v4h4v-4h-4Z"
    />
  </svg>
);
export default SvgComponent;
